import { render, staticRenderFns } from "./CredenciamentoAtualizacaoAcoesProcessoDigital.vue?vue&type=template&id=3bea2eac"
import script from "./CredenciamentoAtualizacaoAcoesProcessoDigital.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAtualizacaoAcoesProcessoDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports